import { render, staticRenderFns } from "./selectcompanygroup.vue?vue&type=template&id=6501e658&"
import script from "./selectcompanygroup.js?vue&type=script&lang=js&"
export * from "./selectcompanygroup.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6501e658')) {
      api.createRecord('6501e658', component.options)
    } else {
      api.reload('6501e658', component.options)
    }
    module.hot.accept("./selectcompanygroup.vue?vue&type=template&id=6501e658&", function () {
      api.rerender('6501e658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectcompanygroup.vue"
export default component.exports